//@flow
import moment from 'moment-timezone';

import TimeUtils from 'common/utils/TimeUtils';

export const DateRangeEnum = Object.freeze({
    today: 'today',
    last7Days: 'last7days',
    last30Days: 'last30days',
    last182days: 'last182days',
    last365days: 'last365days'
});

export type DateRangeEnumType = $Values<typeof DateRangeEnum>;

class DateRangeUtils {
    static getDateRange = (dateRangeString: string) => {
        switch (dateRangeString) {
            case DateRangeEnum.today:
                return { startDate: moment(), endDate: moment() };
            case DateRangeEnum.last7Days:
                return {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment()
                };
            case DateRangeEnum.last30Days:
                return {
                    startDate: moment().subtract(29, 'days'),
                    endDate: moment()
                };
            case DateRangeEnum.last182days:
                return {
                    startDate: moment().subtract(181, 'days'),
                    endDate: moment()
                };
            case DateRangeEnum.last365days:
                return {
                    startDate: moment().subtract(365, 'days'),
                    endDate: moment()
                };
            default:
                return { startDate: moment(), endDate: moment() };
        }
    };

    static getDateRangeFormatted = (
        dateRangeString: string,
        format: string
    ): { startDate: string, endDate: string } => {
        const range = DateRangeUtils.getDateRange(dateRangeString);
        return {
            startDate: TimeUtils.format(range.startDate, format),
            endDate: TimeUtils.format(range.endDate, format)
        };
    };

    static getDateRangeString = (range: {
        startDate: string,
        endDate: string
    }): ?DateRangeEnumType => {
        return Object.values(DateRangeEnum).find(key => {
            const { startDate, endDate } = DateRangeUtils.getDateRange(key);
            return (
                range.startDate === startDate.format('YYYY-MM-DD') &&
                range.endDate === endDate.format('YYYY-MM-DD')
            );
        });
    };
}

export default DateRangeUtils;
